import React, { useEffect, FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "../../components/Component";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

interface ReturnsAsideProps {
  updateSm: (value: boolean) => void;
  sm: boolean;
}

const ReturnsAside: FC<ReturnsAsideProps> = ({ updateSm, sm }) => {
  const { data: allowedRoutes }: any = useSelector(
    (state: RootState) => state.allowedRoutes
  );
  const location = useLocation();

  useEffect(() => {
    sm
      ? document.body.classList.add("toggle-shown")
      : document.body.classList.remove("toggle-shown");
  }, [sm]);

  const isActive = (path: string): string => {
    return location.pathname === path ? "active" : "";
  };

  const LinkTo = ({ path }: { path: string }) => {
    if (!allowedRoutes.includes(path)) {
      return null;
    }
    switch (path) {
      case "view-returns":
        return (
          <Link
            to="/view-returns"
            className={isActive(`${process.env.PUBLIC_URL}/view-returns`)}
          >
            <Icon name="eye-fill" />
            <span>View</span>
          </Link>
        );
      case "pending-approvals-returns":
        return (
          <Link
            to="/pending-approvals-returns"
            className={isActive(
              `${process.env.PUBLIC_URL}/pending-approvals-returns`
            )}
          >
            <Icon name="check-fill-c" />
            <span>Pending Approval</span>
          </Link>
        );
      default:
        return null;
    }
  };

  return (
    <div className="card-inner-group">
      <div className="card-inner">
        <div className="user-account-info py-0">
          <h6 className="overline-title-alt" style={{ fontSize: 14 }}>
            Purchase Return
          </h6>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          {["view-returns", "pending-approvals-returns"].map((item) => (
            <li key={item} onClick={() => updateSm(false)}>
              <LinkTo path={item} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ReturnsAside;
